// extracted by mini-css-extract-plugin
module.exports = {"pill":"shorts-pill_pill__2de0e","text":"shorts-pill_text__1LdOM"};